import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoClaimsPutRes } from "./abst/DtoClaimsPutRes";

export class DtoClaimsPutResImple extends DtoClaimsPutRes {}
